import beiersdorf from '../assets/logos/beiersdorf.png'
import callways from '../assets/logos/callways.png'
import frankfurtSchool from '../assets/logos/frankfurt-school.png'
import lufthansa from '../assets/logos/lufthansa.png'
import mci from '../assets/logos/mci.png'
import omr from '../assets/logos/omr.png'
import personaService from '../assets/logos/persona-service.png'

/**
 * Copy der Produkt-Demo, Inhalte aus dem Demo-Deck 2026 (v12).
 * Zahlen und Fallstudien wie im Deck, Report und Profil sind Beispieldaten.
 */

export const LOGOS = {
  lufthansa,
  callways,
  mci,
  frankfurtSchool,
  omr,
  beiersdorf,
  personaService
}

// Beispiel für Anforderungsprofil und Report, Werte 0 bis 100
export const DIMS = [
  {
    key: 'problem',
    must: true,
    ideal: [60, 90],
    trans: [50, 96],
    experts: [64, 74, 84],
    person: 80
  },
  {
    key: 'math',
    ideal: [36, 62],
    trans: [26, 76],
    experts: [42, 50, 56],
    person: 71
  },
  {
    key: 'verbal',
    ideal: [50, 80],
    trans: [40, 88],
    experts: [56, 64, 74],
    person: 66
  },
  {
    key: 'memory',
    ideal: [56, 86],
    trans: [46, 92],
    experts: [62, 70, 80],
    person: 33
  }
]

export const fitOf = (d) =>
  d.person >= d.ideal[0] && d.person <= d.ideal[1]
    ? 'high'
    : d.person >= d.trans[0] && d.person <= d.trans[1]
      ? 'mid'
      : 'low'

export const SCORE = 82

// Reihenfolge der Fallstudien wie im Deck, `branch` ist der Schlüssel für ?branche=
const CASES = [
  { id: 'omr', logo: omr, initials: 'KK', branch: 'medien' },
  { id: 'beiersdorf', logo: beiersdorf, initials: 'CF', branch: 'industrie' },
  { id: 'callways', logo: callways, initials: 'AR', branch: 'dienstleistung' },
  { id: 'mci', logo: mci, initials: 'MK', branch: 'dienstleistung' },
  { id: 'persona', logo: personaService, initials: 'CS', branch: 'personal' },
  { id: 'fs', logo: frankfurtSchool, initials: 'AF', branch: 'bildung' },
  { id: 'lufthansa', logo: lufthansa, initials: 'SB', branch: 'logistik' }
]

const de = {
  ui: {
    chapters: 'Kapitel',
    sample: 'Beispieldaten',
    cue: 'Scroll los',
    locale: 'de-DE'
  },
  chapters: {
    intro: 'Vorher wissen',
    problem: 'Das Problem',
    hebel: 'Der Hebel',
    schritte: 'Drei Schritte',
    analyse: 'I. Anforderungen',
    testung: 'II. Testung',
    perspektiven: 'Vier Perspektiven',
    matching: 'III. Matching',
    prozess: 'Im Prozess',
    wissenschaft: 'Wissenschaft',
    faelle: 'Erfolgsgeschichten',
    abschluss: 'Nächste Schritte'
  },
  dims: {
    problem: 'Problemlösefähigkeit',
    math: 'Mathematisches Verständnis',
    verbal: 'Sprachliche Problemlösefähigkeit',
    memory: 'Merkfähigkeit'
  },
  intro: {
    eyebrow: 'Software für fundierte Vorauswahl im Recruiting',
    lead: 'Vorher wissen,',
    title: 'mit wem das Gespräch lohnt.',
    stats: [
      { to: 30, suffix: ' %', label: 'weniger Fehlentscheidungen' },
      { to: 70, suffix: ' %', label: 'weniger Aufwand in der Vorauswahl' },
      { to: 9, suffix: ' von 10', label: 'Bewerbenden bevorzugen Aivy' }
    ],
    sources:
      'Quellen: Frankfurt School Case Study (N = 56), Callways Case Study, Aivy-Nutzertest (N = 450)',
    badges: [
      'DIN 33430 konform',
      'EU AI Act sicher',
      'Serverstandort Frankfurt'
    ],
    trust: '200+ HR-Teams jeder Größe und Branche vertrauen Aivy'
  },
  problem: {
    eyebrow: 'Das Problem',
    title: 'Unterlagen entscheiden zu oft allein.',
    sub: 'Obwohl sie nur einen Teil zeigen.',
    cv: 'Lebenslauf',
    visible: 'Sichtbar',
    visibleItems: ['Lebenslauf', 'Zeugnisse', 'Stationen'],
    hidden: 'Unsichtbar',
    hiddenItems: [
      'Problemlösen',
      'Sorgfalt',
      'Belastbarkeit',
      'Motivation',
      'Passung'
    ],
    problems: [
      {
        title: 'Dauert zu lange',
        text: 'Hunderte Bewerbungen, kaum Zeit für echte Beurteilung.'
      },
      {
        title: 'Unsichere Entscheidungen',
        text: 'Schwer zu begründen und noch schwerer zu verteidigen.'
      },
      {
        title: 'Versteckte Potenziale',
        text: 'Lückenhafte Lebensläufe sortieren Menschen aus, die passen würden.'
      }
    ]
  },
  hebel: {
    eyebrow: 'Der Hebel',
    before: 'Klarheit entsteht heute erst im Gespräch.',
    after: 'Aivy holt sie davor.',
    without: 'Ohne strukturierte Vorauswahl',
    with: 'Mit Aivy',
    rows: [
      [
        'Die Unterlagen entscheiden, wer überhaupt eingeladen wird',
        'Die Messlatte steht, bevor die erste Bewerbung kommt'
      ],
      [
        'Jede Person, die das Gespräch führt, urteilt anders',
        'Stärken werden gemessen statt geschätzt, für alle gleich'
      ],
      [
        'Die Begründung kommt hinterher und ist schwer belastbar',
        'Jede Entscheidung ist dokumentiert und nachvollziehbar'
      ],
      [
        'Eine Fehlbesetzung zeigt sich erst nach der Einstellung',
        'Das Gespräch klärt die offenen Punkte statt der Grundlagen'
      ]
    ],
    proof: [
      {
        to: 70,
        label: 'weniger Aufwand in der Vorauswahl',
        source: 'Fallstudie Callways'
      },
      {
        to: 96,
        label: 'Übereinstimmung mit dem eigenen Assessment Center',
        source: 'Fallstudie Lufthansa Group'
      },
      {
        to: 30,
        label: 'weniger Fehlentscheidungen',
        source: 'Fallstudie Frankfurt School'
      }
    ]
  },
  schritte: {
    eyebrow: 'So funktioniert Aivy',
    title: 'In drei Schritten zu mehr Passung.',
    sub: 'Schnell, fair und nachvollziehbar.',
    steps: [
      {
        title: 'Anforderungen definieren',
        text: 'Mehrere Fach- und Personalverantwortliche schätzen unabhängig voneinander ein, was die Stelle wirklich braucht. 5 bis 10 Minuten pro Person.'
      },
      {
        title: 'Stärken sichtbar machen',
        text: 'Bewerbende lösen spielbasierte Verfahren am Smartphone oder PC. Jedes dauert 2 bis 5 Minuten, ohne Vorbereitung und ohne Lebenslauf.'
      },
      {
        title: 'Ergebnisreport erhalten',
        text: 'Das Profil wird gegen die Anforderungen gerechnet. Ihr seht einen Gesamtscore und die Passung je Dimension.'
      }
    ],
    addon: 'Add-on SmartPredict',
    addonText:
      'Anforderungen und Matching lernen laufend aus euren Einstellungsdaten und werden mit jeder Runde treffsicherer.'
  },
  analyse: {
    eyebrow: 'I. Analyse der Anforderungen',
    title: 'Erst die Messlatte. Dann die Bewerbungen.',
    sources: [
      'Expertise von Kolleg:innen einholen',
      'Vorlage von Aivy nutzen',
      'Bestehende Mitarbeitende testen'
    ],
    experts: ['Fachbereich', 'HR', 'Teamleitung'],
    target: 'Zielbereich',
    tolerance: 'Toleranz',
    must: 'Muss',
    chips: [
      'Kurzer Online-Fragebogen',
      '5 bis 10 Minuten pro Person',
      'Anforderungsprofil nach DIN 33430'
    ]
  },
  testung: {
    eyebrow: 'II. Testung der Stärken',
    split: ['Kein Fragebogen.', 'Ein Spiel.'],
    hello: 'Hallo!',
    intro: 'Zeig deine Stärken in drei kurzen Spielen.',
    start: 'Los geht’s',
    games: [
      { title: 'Codeknacker', dim: 'Merkfähigkeit' },
      { title: 'Gefühlschaos', dim: 'Emotionswahrnehmung' },
      { title: 'Dreamteam', dim: 'Kultur' }
    ],
    captions: [
      {
        eyebrow: 'Aus Sicht der Bewerbenden',
        text: 'Eine kurze Aufgabe am Smartphone.'
      },
      { eyebrow: 'Nutzendenbefragung', text: '9 von 10 bevorzugen Aivy.' },
      { eyebrow: 'EnBW Auswertung', text: '94 % Abschlussrate.' },
      {
        eyebrow: 'Unaufgeforderte Rückmeldung an das HR-Team',
        text: '„Das war der mit Abstand coolste Test dieser Art.“'
      }
    ],
    library: '12 validierte Verfahren · je 2 bis 5 Minuten · DIN 33430',
    profile: 'Dein Stärkenprofil',
    strengths: [
      { title: 'Empathie', text: 'Du erkennst schnell, wie es anderen geht.' },
      { title: 'Vorausplanen', text: 'Du denkst mehrere Schritte voraus.' },
      { title: 'Merkfähigkeit', text: 'Du behältst viele Details im Kopf.' }
    ]
  },
  perspektiven: {
    eyebrow: 'Was Aivy misst',
    title: 'Vier Perspektiven.',
    sub: 'Aivy macht sichtbar, was Lebensläufe nicht zeigen. Abgeglichen mit den Anforderungen der Stelle.',
    groups: [
      {
        title: 'Fähigkeiten',
        question:
          'Kann eine Person die zentralen Anforderungen der Rolle bewältigen?',
        tag: 'Kognitiv und sozial',
        items: [
          'Sprachliche Problemlösefähigkeit',
          'Merkfähigkeit',
          'Emotionswahrnehmung',
          'Aufmerksamkeit',
          'Mathematisches Verständnis',
          'Problemlösefähigkeit'
        ]
      },
      {
        title: 'Persönlichkeit',
        question: 'Wie arbeitet, entscheidet und reagiert eine Person?',
        tag: 'Big Five und arbeitsbezogene Merkmale',
        items: [
          'Verträglichkeit',
          'Gewissenhaftigkeit',
          'Extraversion',
          'Emotionalität',
          'Offenheit für Neues',
          'Verantwortungsbereitschaft',
          'Risikobereitschaft'
        ]
      },
      {
        title: 'Werte und Kultur',
        question: 'Welche Arbeitsumgebung passt zu einer Person?',
        tag: 'Zwei Kulturachsen, erweiterbar',
        items: [
          'Stabilität',
          'Flexibilität',
          'Unabhängigkeit',
          'Zusammenarbeit'
        ]
      },
      {
        title: 'Berufliche Interessen',
        question: 'Welche Tätigkeiten sprechen eine Person an?',
        tag: 'RIASEC und Interessenvielfalt',
        items: [
          'Handwerklich-technisch',
          'Untersuchend-forschend',
          'Künstlerisch-kreativ',
          'Erziehend-pflegend',
          'Führend-verkaufend',
          'Ordnend-verwaltend',
          'Interessenvielfalt'
        ]
      }
    ]
  },
  matching: {
    eyebrow: 'III. Matching der Passung',
    title: 'Noch vor dem ersten Gespräch.',
    report: 'Ergebnisreport · Fähigkeiten',
    person: 'Wert der Person',
    target: 'Zielbereich',
    tolerance: 'Toleranz',
    must: 'Muss',
    score: 'Gesamtscore',
    scoreLabel: 'Hohe Passung',
    note: 'Gerechnet gegen das Anforderungsprofil, nicht gegen das Bewerberfeld.',
    detailTitle: 'Aus der Abweichung wird ein Hinweis.',
    detailText:
      'Das mathematische Verständnis der Person ist eher überdurchschnittlich. Damit passt sie eher gut zur mittleren Relevanz quantitativer Methoden in der Stelle.',
    hints: [
      {
        icon: '!',
        title: 'Risiken',
        text: 'Trotz hoher Leistung könnte die Person unzufrieden werden, wenn sie sich überqualifiziert fühlt.'
      },
      {
        icon: '?',
        title: 'Empfehlung für das Interview',
        text: 'Frag nach, wie wichtig ihr anspruchsvolle analytische Aufgaben sind und welche Rolle Zahlen im Wunschjob spielen.'
      },
      {
        icon: '+',
        title: 'Maßnahmen im Fall der Einstellung',
        text: 'Übertrag ihr gezielt datengetriebene Aufgaben oder Projekte, die ihre analytische Stärke fordern.'
      }
    ]
  },
  prozess: {
    eyebrow: 'Wo Aivy im Prozess einsteigt',
    title: 'Direkt am Eingang. Automatisiert über das ATS.',
    stages: [
      'Bewerbung geht ein',
      'Vorauswahl',
      'Interview',
      'Endrunde',
      'Zusage'
    ],
    badge: 'Best Practice',
    text: 'Jede Bewerbung wird zum Test eingeladen, bevor jemand sichtet. Euer Bewerbermanagementsystem löst die Einladung beim Statuswechsel aus, das Ergebnis landet in derselben Bewerberakte.',
    addons: ['Add-on Orientierung', 'Add-on Entwicklung'],
    later: 'Auch später möglich, etwa vor der Endrunde.',
    proof: 'Callways · 70 % weniger Aufwand in der Vorauswahl',
    sent: ['Zufällige Kennung', 'Rolle', 'Anforderungsprofil'],
    kept: ['Name', 'Unterlagen'],
    privacy:
      'An Aivy gehen nur Kennung, Rolle und Anforderungsprofil. Name und Unterlagen bleiben im führenden System.',
    ats: 'Euer ATS'
  },
  wissenschaft: {
    title: 'Wissenschaftlich entwickelt, in der Praxis bewährt.',
    sub: 'Entstanden aus Forschung an der Freien Universität Berlin, entwickelt entlang der DIN 33430.',
    stats: [
      { to: 1000000, suffix: '+', label: 'Testungen durchgeführt' },
      { to: 200, suffix: '+', label: 'Unternehmen im Einsatz' },
      { to: 5, suffix: '+', label: 'Jahre in echten Prozessen' }
    ],
    badges: [
      'DIN 33430 konform',
      'EU AI Act sicher',
      'Serverstandort Frankfurt'
    ]
  },
  faelle: {
    eyebrow: 'Erfolgsgeschichten aus dem Einsatz',
    title: 'Was Teams mit Aivy erreichen.',
    filter: 'Branche',
    all: 'Alle',
    cases: {
      omr: {
        name: 'OMR',
        value: '15 Min.',
        valueLabel: 'Testdauer im Auswahlprozess',
        text: 'OMR setzt Aivy direkt nach Bewerbungseingang ein, vereinheitlicht Anforderungen und erkennt Talente, die im klassischen CV-Screening übersehen worden wären.',
        quote:
          '„Wir hatten Fälle, die wir sonst abgesagt hätten, Aivy zeigte Potenzial. Wir haben eingeladen und sogar eingestellt.“',
        author: 'Kaya Kruse · People Lead, OMR',
        branch: 'Medien'
      },
      beiersdorf: {
        name: 'Beiersdorf',
        value: '20.000+',
        valueLabel: 'absolvierte Self-Assessments',
        text: 'Beiersdorf setzt Aivy schon vor der Bewerbung zur Berufsorientierung ein und empfiehlt Studierenden passende Praktikumsbereiche anhand ihrer Stärken.',
        quote:
          '„Tolle UX, saubere Diagnostik, ein fehlendes Puzzlestück für gute Candidate Experience bei Beiersdorf.“',
        author:
          'Carl-Christoph Fellinger · Strategic Talent Acquisition, Beiersdorf',
        branch: 'Industrie'
      },
      callways: {
        name: 'Callways',
        value: '70 %',
        valueLabel: 'weniger Aufwand in der Vorauswahl',
        text: 'Callways senkt mit Aivy den Screening-Aufwand um 70 %, in Zeiten von KI-geschriebenen Bewerbungen.',
        quote:
          '„Wir schicken allen sofort den Aivy-Link. Es ist ein Geschenk für beide Seiten.“',
        author: 'Achim Reinhardt · Co-CEO, Callways',
        branch: 'Dienstleistung'
      },
      mci: {
        name: 'MCI',
        value: '55 %',
        valueLabel: 'kürzere Time-to-Hire',
        text: 'MCI hat Aivy in sein Bewerbermanagement integriert, die Time-to-Hire auf 75 Tage reduziert und spart rund 90 % der Kosten pro Einstellung.',
        quote:
          '„Wir haben unsere Time-to-Hire mehr als halbiert und dabei valide Einblicke gewonnen.“',
        author:
          'Matthias Kühne · Director Business Administration, MCI Deutschland',
        branch: 'Dienstleistung'
      },
      persona: {
        name: 'persona service',
        value: '15 Min.',
        valueLabel: 'bis Stärken sichtbar werden',
        text: 'persona service fand mit Aivy eine Kandidatin für eine Teamleitung, die anhand ihres Lebenslaufs wahrscheinlich nicht eingeladen worden wäre.',
        quote:
          '„Wenn ich rein vom Lebenslauf ausgehe, hätte ich sie wahrscheinlich nicht zum Vorstellungsgespräch eingeladen.“',
        author: 'Christin Seel · Regionalleiterin, persona service',
        branch: 'Personaldienstleistung'
      },
      fs: {
        name: 'Frankfurt School',
        value: '5×',
        valueLabel: 'höhere Vorhersagekraft',
        text: 'Die Frankfurt School testete Aivy gegen klassische Unterlagen. Der Passungsscore sagte das spätere Abschneiden im Assessment Center fünfmal stärker vorher.',
        quote:
          '„Eine sehr kreative Möglichkeit, mehr über einen Bewerbenden zu lernen.“',
        author: 'Anonymes Feedback aus dem Auswahlprozess',
        branch: 'Bildung'
      },
      lufthansa: {
        name: 'Lufthansa',
        value: '96 %',
        valueLabel: 'Trefferquote vor dem Interview',
        text: 'Lufthansa wählt mit Aivy für das Traineeprogramm vor. Bei den später im Assessment Center geprüften Kandidat:innen stimmten 25 von 26 Eignungsentscheidungen.',
        quote:
          '„Wir erhalten darüber einen besseren Blick auf die Person und erkennen ihre Stärken.“',
        author:
          'Susanne Berthold Neumann · Innovative Nachwuchsprogramme, Deutsche Lufthansa AG',
        branch: 'Logistik und Mobilität'
      }
    }
  },
  abschluss: {
    title: 'Chancengeber statt nur Arbeitgeber.',
    sub: 'Vorher wissen, mit wem das Gespräch lohnt.',
    why: 'Warum Aivy',
    points: [
      {
        title: 'Ansprechend für Bewerbende',
        text: 'Spielbasiert, 20 bis 30 Minuten und mit eigenem Stärkenprofil zurück.'
      },
      {
        title: 'Einfach zu nutzen für Unternehmen',
        text: 'Vorauswahl ohne Sichtungsmarathon.'
      },
      {
        title: 'Treffsicher für Entscheidungen',
        text: 'Gemessen gegen das Anforderungsprofil und dokumentiert.'
      }
    ],
    next: 'Die nächsten Schritte',
    steps: [
      {
        title: 'Kennenlernen',
        text: 'Bedarfsanalyse mit den relevanten Stakeholdern'
      },
      { title: 'Vorstellung', text: 'Präsentation und offene Fragen' },
      { title: 'Business Case', text: 'Planung Go-live und passende Features' },
      { title: 'Start als #HeRo', text: 'Einbindung und Onboarding' }
    ],
    cta: 'Gespräch vereinbaren',
    ctaHref: 'https://www.aivy.app/gespraech-vereinbaren',
    candidate: 'Aus Sicht der Bewerbenden',
    again: 'Nochmal von vorn'
  }
}

const en = {
  ui: {
    chapters: 'Chapters',
    sample: 'Sample data',
    cue: 'Scroll to start',
    locale: 'en-US'
  },
  chapters: {
    intro: 'Know in advance',
    problem: 'The problem',
    hebel: 'The lever',
    schritte: 'Three steps',
    analyse: 'I. Requirements',
    testung: 'II. Assessment',
    perspektiven: 'Four perspectives',
    matching: 'III. Matching',
    prozess: 'In your process',
    wissenschaft: 'Science',
    faelle: 'Success stories',
    abschluss: 'Next steps'
  },
  dims: {
    problem: 'Problem solving',
    math: 'Numerical reasoning',
    verbal: 'Verbal problem solving',
    memory: 'Memory'
  },
  intro: {
    eyebrow: 'Software for evidence-based pre-selection in recruiting',
    lead: 'Know in advance',
    title: 'who is worth the interview time.',
    stats: [
      { to: 30, suffix: ' %', label: 'fewer wrong decisions' },
      { to: 70, suffix: ' %', label: 'less effort in pre-selection' },
      { to: 9, suffix: ' out of 10', label: 'candidates prefer Aivy' }
    ],
    sources:
      'Sources: Frankfurt School case study (N = 56), Callways case study, Aivy user test (N = 450)',
    badges: ['DIN 33430 compliant', 'EU AI Act ready', 'Servers in Frankfurt'],
    trust: '200+ HR teams of every size and industry trust Aivy'
  },
  problem: {
    eyebrow: 'The problem',
    title: 'Documents decide far too often on their own.',
    sub: 'Even though they only show part of the picture.',
    cv: 'CV',
    visible: 'Visible',
    visibleItems: ['CV', 'Certificates', 'Career steps'],
    hidden: 'Invisible',
    hiddenItems: [
      'Problem solving',
      'Diligence',
      'Resilience',
      'Motivation',
      'Fit'
    ],
    problems: [
      {
        title: 'Takes too long',
        text: 'Hundreds of applications, hardly any time for real assessment.'
      },
      {
        title: 'Decisions you cannot defend',
        text: 'Hard to justify and even harder to defend.'
      },
      {
        title: 'Hidden potential',
        text: 'Patchy CVs screen out people who would have been a good fit.'
      }
    ]
  },
  hebel: {
    eyebrow: 'The lever',
    before: 'Today, clarity only emerges in the interview.',
    after: 'Aivy brings it forward.',
    without: 'Without structured pre-selection',
    with: 'With Aivy',
    rows: [
      [
        'The documents decide who gets invited at all',
        'The bar is set before the first application arrives'
      ],
      [
        'Every interviewer judges differently',
        'Strengths are measured, not guessed, the same way for everyone'
      ],
      [
        'The reasoning comes afterwards and does not hold up well',
        'Every decision is documented and traceable'
      ],
      [
        'A bad hire only shows up after the hire',
        'The interview covers the open questions instead of the basics'
      ]
    ],
    proof: [
      {
        to: 70,
        label: 'less effort in pre-selection',
        source: 'Case study Callways'
      },
      {
        to: 96,
        label: 'agreement with the company’s own assessment centre',
        source: 'Case study Lufthansa Group'
      },
      {
        to: 30,
        label: 'fewer wrong decisions',
        source: 'Case study Frankfurt School'
      }
    ]
  },
  schritte: {
    eyebrow: 'How Aivy works',
    title: 'Better fit in three steps.',
    sub: 'Fast, fair and transparent.',
    steps: [
      {
        title: 'Define the requirements',
        text: 'Several hiring managers and HR colleagues rate independently what the role really needs. 5 to 10 minutes per person.'
      },
      {
        title: 'Make strengths visible',
        text: 'Candidates complete game-based assessments on a phone or computer. Each one takes 2 to 5 minutes, no preparation and no CV.'
      },
      {
        title: 'Get the result report',
        text: 'The profile is scored against the requirements. You get an overall score plus the fit for every dimension.'
      }
    ],
    addon: 'Add-on SmartPredict',
    addonText:
      'Requirements and matching keep learning from your hiring data and get more accurate with every round.'
  },
  analyse: {
    eyebrow: 'I. Analysing the requirements',
    title: 'First the bar. Then the applications.',
    sources: [
      'Gather input from colleagues',
      'Use an Aivy template',
      'Assess current employees'
    ],
    experts: ['Department', 'HR', 'Team lead'],
    target: 'Target range',
    tolerance: 'Tolerance',
    must: 'Must',
    chips: [
      'Short online questionnaire',
      '5 to 10 minutes per person',
      'Requirement profile based on DIN 33430'
    ]
  },
  testung: {
    eyebrow: 'II. Assessing strengths',
    split: ['Not a questionnaire.', 'A game.'],
    hello: 'Hi there!',
    intro: 'Show your strengths in three short games.',
    start: 'Let’s go',
    games: [
      { title: 'Code Cracker', dim: 'Memory' },
      { title: 'Emotional Chaos', dim: 'Emotion perception' },
      { title: 'Dream Team', dim: 'Culture' }
    ],
    captions: [
      {
        eyebrow: 'From the candidate’s side',
        text: 'A short task on a phone.'
      },
      { eyebrow: 'User survey', text: '9 out of 10 prefer Aivy.' },
      { eyebrow: 'EnBW analysis', text: '94 % completion rate.' },
      {
        eyebrow: 'Unprompted feedback to the HR team',
        text: '“By far the coolest test of its kind.”'
      }
    ],
    library: '12 validated assessments · 2 to 5 minutes each · DIN 33430',
    profile: 'Your strengths profile',
    strengths: [
      { title: 'Empathy', text: 'You quickly sense how others feel.' },
      { title: 'Planning ahead', text: 'You think several steps ahead.' },
      { title: 'Memory', text: 'You keep lots of details in mind.' }
    ]
  },
  perspektiven: {
    eyebrow: 'What Aivy measures',
    title: 'Four perspectives.',
    sub: 'Aivy makes visible what CVs do not show. Matched against the requirements of the role.',
    groups: [
      {
        title: 'Abilities',
        question: 'Can this person handle the core requirements of the role?',
        tag: 'Cognitive and social',
        items: [
          'Verbal problem solving',
          'Memory',
          'Emotion perception',
          'Attention',
          'Numerical reasoning',
          'Problem solving'
        ]
      },
      {
        title: 'Personality',
        question: 'How does this person work, decide and react?',
        tag: 'Big Five and work-related traits',
        items: [
          'Agreeableness',
          'Conscientiousness',
          'Extraversion',
          'Emotionality',
          'Openness',
          'Sense of responsibility',
          'Risk appetite'
        ]
      },
      {
        title: 'Values and culture',
        question: 'Which working environment suits this person?',
        tag: 'Two culture axes, extendable',
        items: ['Stability', 'Flexibility', 'Independence', 'Collaboration']
      },
      {
        title: 'Vocational interests',
        question: 'Which kinds of work appeal to this person?',
        tag: 'RIASEC and breadth of interests',
        items: [
          'Realistic',
          'Investigative',
          'Artistic',
          'Social',
          'Enterprising',
          'Conventional',
          'Breadth of interests'
        ]
      }
    ]
  },
  matching: {
    eyebrow: 'III. Matching the fit',
    title: 'Before the first interview.',
    report: 'Result report · abilities',
    person: 'Person’s score',
    target: 'Target range',
    tolerance: 'Tolerance',
    must: 'Must',
    score: 'Overall score',
    scoreLabel: 'Strong fit',
    note: 'Scored against the requirement profile, not against the other applicants.',
    detailTitle: 'A deviation becomes a pointer.',
    detailText:
      'The person’s numerical reasoning is rather above average. That fits reasonably well with the medium relevance of quantitative methods in the role.',
    hints: [
      {
        icon: '!',
        title: 'Risks',
        text: 'Despite strong performance, the person might become dissatisfied if they feel overqualified.'
      },
      {
        icon: '?',
        title: 'Recommendation for the interview',
        text: 'Ask how much demanding analytical work matters to them and what role numbers play in their ideal job.'
      },
      {
        icon: '+',
        title: 'Measures if you hire',
        text: 'Give them data-driven tasks or projects that challenge their analytical strength.'
      }
    ]
  },
  prozess: {
    eyebrow: 'Where Aivy enters your process',
    title: 'Right at the intake. Triggered by your ATS.',
    stages: [
      'Application arrives',
      'Pre-selection',
      'Interview',
      'Final round',
      'Offer'
    ],
    badge: 'Best practice',
    text: 'Every applicant is invited to the assessment before anyone screens. Your applicant tracking system sends the invitation on a status change, and the result lands in the same candidate record.',
    addons: ['Add-on orientation', 'Add-on development'],
    later: 'Also possible later, for example before the final round.',
    proof: 'Callways · 70 % less effort in pre-selection',
    sent: ['Random ID', 'Role', 'Requirement profile'],
    kept: ['Name', 'Documents'],
    privacy:
      'Aivy only receives an ID, the role and the requirement profile. Name and documents stay in your system of record.',
    ats: 'Your ATS'
  },
  wissenschaft: {
    title: 'Scientifically developed, proven in practice.',
    sub: 'Born out of research at Freie Universität Berlin, developed in line with DIN 33430.',
    stats: [
      { to: 1000000, suffix: '+', label: 'assessments completed' },
      { to: 200, suffix: '+', label: 'companies using Aivy' },
      { to: 5, suffix: '+', label: 'years in real hiring processes' }
    ],
    badges: ['DIN 33430 compliant', 'EU AI Act ready', 'Servers in Frankfurt']
  },
  faelle: {
    eyebrow: 'Success stories from the field',
    title: 'What teams achieve with Aivy.',
    filter: 'Industry',
    all: 'All',
    cases: {
      omr: {
        name: 'OMR',
        value: '15 min',
        valueLabel: 'assessment time in the selection process',
        text: 'OMR uses Aivy right after applications arrive, standardises requirements and spots talent that classic CV screening would have missed.',
        quote:
          '“We had cases we would otherwise have rejected, and Aivy showed potential. We invited them in and even hired them.”',
        author: 'Kaya Kruse · People Lead, OMR',
        branch: 'Media'
      },
      beiersdorf: {
        name: 'Beiersdorf',
        value: '20,000+',
        valueLabel: 'self-assessments completed',
        text: 'Beiersdorf uses Aivy for career orientation even before people apply, recommending internship areas that match students’ strengths.',
        quote:
          '“Great UX, sound diagnostics, a missing piece of the puzzle for a good candidate experience at Beiersdorf.”',
        author:
          'Carl-Christoph Fellinger · Strategic Talent Acquisition, Beiersdorf',
        branch: 'Industry'
      },
      callways: {
        name: 'Callways',
        value: '70 %',
        valueLabel: 'less effort in pre-selection',
        text: 'Callways cuts screening effort by 70 % with Aivy, in a time of AI-written applications.',
        quote:
          '“We send everyone the Aivy link straight away. It is a gift for both sides.”',
        author: 'Achim Reinhardt · Co-CEO, Callways',
        branch: 'Services'
      },
      mci: {
        name: 'MCI',
        value: '55 %',
        valueLabel: 'shorter time to hire',
        text: 'MCI integrated Aivy into its applicant tracking system, brought time to hire down to 75 days and saves around 90 % of the cost per hire.',
        quote:
          '“We more than halved our time to hire and gained valid insights along the way.”',
        author:
          'Matthias Kühne · Director Business Administration, MCI Deutschland',
        branch: 'Services'
      },
      persona: {
        name: 'persona service',
        value: '15 min',
        valueLabel: 'until strengths become visible',
        text: 'persona service used Aivy to find a candidate for a team lead role who, judging by her CV alone, would probably not have been invited.',
        quote:
          '“Going by the CV alone, I probably would not have invited her to interview.”',
        author: 'Christin Seel · Regional Director, persona service',
        branch: 'Staffing'
      },
      fs: {
        name: 'Frankfurt School',
        value: '5×',
        valueLabel: 'higher predictive power',
        text: 'Frankfurt School tested Aivy against conventional documents. The fit score predicted later assessment centre performance five times more strongly.',
        quote: '“A very creative way to learn more about a candidate.”',
        author: 'Anonymous feedback from the selection process',
        branch: 'Education'
      },
      lufthansa: {
        name: 'Lufthansa',
        value: '96 %',
        valueLabel: 'hit rate before the interview',
        text: 'Lufthansa pre-selects for its trainee programme with Aivy. Among candidates later assessed in the assessment centre, 25 of 26 suitability decisions were correct.',
        quote:
          '“It gives us a better view of the person and lets us see their strengths.”',
        author:
          'Susanne Berthold Neumann · Innovative Trainee Programmes, Deutsche Lufthansa AG',
        branch: 'Logistics and mobility'
      }
    }
  },
  abschluss: {
    title: 'An opportunity giver, not just an employer.',
    sub: 'Know in advance who is worth the interview time.',
    why: 'Why Aivy',
    points: [
      {
        title: 'Appealing for candidates',
        text: 'Game-based, 20 to 30 minutes, and they get their own strengths profile back.'
      },
      {
        title: 'Easy to use for companies',
        text: 'Pre-selection without the screening marathon.'
      },
      {
        title: 'Accurate for decisions',
        text: 'Measured against the requirement profile, and documented.'
      }
    ],
    next: 'The next steps',
    steps: [
      {
        title: 'Intro call',
        text: 'Needs analysis with the relevant stakeholders'
      },
      { title: 'Demo', text: 'Presentation and open questions' },
      {
        title: 'Business case',
        text: 'Go-live planning and matching features'
      },
      { title: 'Live as a #HeRo', text: 'Integration and onboarding' }
    ],
    cta: 'Book a call',
    ctaHref: 'https://www.aivy.app/gespraech-vereinbaren',
    candidate: 'The candidate’s view',
    again: 'Start over'
  }
}

export const DEMO_CASES = CASES
export const DEMO_COPY = { de, en }
